const PREFIX = '[DEFERRED_PAYMENTS]';

export const MAKE_PAYMENT_REQUEST = `${PREFIX} MAKE_PAYMENT_REQUEST`;
export const MAKE_PAYMENT_SUCCESS = `${PREFIX} MAKE_PAYMENT_SUCCESS`;
export const MAKE_PAYMENT_FAILURE = `${PREFIX} MAKE_PAYMENT_FAILURE`;
export const MAKE_PAYMENT_UNKNOWN_STATE = `${PREFIX} MAKE_PAYMENT_UNKNOWN_STATE`;
export const MAKE_PAYMENT_CARD_DECLINED = `${PREFIX} MAKE_PAYMENT_CARD_DECLINED`;
